// On the school's own Hiring app, when signing in cannot complete (a spent
// hand-off, a loop, another school's session): what happened and Try again,
// which goes back to the school's sign-in. Never a form (one sign-in).
import React from 'react';
import { Logo, Button, Icon } from '../../ds';
import { retrySignIn } from '../../standalone';

export default function StandaloneNotice({ message }) {
  return (
    <div className="eq-ds eq-root" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16, background: 'var(--page-bg)' }}>
      <div role="alert" style={{ maxWidth: 420, display: 'grid', gap: 20, justifyItems: 'center', textAlign: 'center', fontFamily: 'var(--font-body)', color: 'var(--text-1)' }}>
        <Logo size={36} />
        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.5 }}>{message}</p>
        <Button variant="primary" icon={<Icon name="arrow-clockwise" />} onClick={retrySignIn}>Try again</Button>
      </div>
    </div>
  );
}
